import { render, staticRenderFns } from "./PackCartItem.vue?vue&type=template&id=ffe5ecc0&scoped=true"
import script from "./PackCartItem.vue?vue&type=script&lang=js"
export * from "./PackCartItem.vue?vue&type=script&lang=js"
import style0 from "./PackCartItem.vue?vue&type=style&index=0&id=ffe5ecc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe5ecc0",
  null
  
)

export default component.exports